import { render } from "./UnReached.vue?vue&type=template&id=b0ad0ddc&scoped=true"
import script from "./UnReached.vue?vue&type=script&lang=js"
export * from "./UnReached.vue?vue&type=script&lang=js"

import "./UnReached.vue?vue&type=style&index=0&id=b0ad0ddc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ad0ddc"]])

export default __exports__